import { useState } from 'react';
import type { IProduct } from '@recargas-dominicanas/core/types';
import { CustomerApi } from '@recargas-dominicanas/core/adminApi';
import { TextField } from '@recargas-dominicanas/core/components';
import { ProductSelect } from '../../../../components/product-select/product-select.component';
import { Modal } from '../../../../components/modal/modal.component';
import { BusinessStore } from '../../../../store/businessStore';
import { useForm } from '@recargas-dominicanas/core/hooks';
import { style } from './add-product-modal.module.css';

interface Props {
  open: boolean;
  customerId: number;
  businessId: number;
  onClose: () => void;
}

export function AddProductModal(props: Props) {

  const { 
    open, 
    customerId, 
    businessId, 
    onClose 
  } = props;

  const [error, setError] = useState<string>();
  
  const form = useForm({
    product: { value: undefined as IProduct | undefined },
    profit: ''
  });

  async function handleSave() {

    if (!form.validate()) return;

    setError(undefined);

    try {

      await CustomerApi.addProduct(customerId, {
        profit: parseFloat(form.profit.value),
        productId: form.product.value!.id
      });

      await BusinessStore.fetchCustomerProducts(businessId, customerId);

      handleClose();

    } catch {

      setError('Error guardando producto');
    }
  }

  function handleClose() {
    form.clear();
    setError(undefined);
    onClose();
  }

  return (
    <Modal
      open={open}
      title='Agregar producto'
      style={style.modal}
      secondaryButton='Agregar'
      error={error}
      onClose={handleClose}
      onSecondaryClick={handleSave}>
      <ProductSelect
        className={style.select}
        label='Producto'
        placeholder='Seleccionar producto'
        value={form.product.value}
        error={form.product.error}
        onChange={form.product.onChange}/>
      <TextField 
        style={style.textField}
        label='Beneficio'
        type='number'
        value={form.profit.value}
        error={form.profit.error}
        onChange={form.profit.onChange}
        onBlur={form.profit.onBlur}/>
    </Modal>
  );
}
